import ko from 'knockout';
import { Metric } from './metrics';

export class InputDataDefinition {
  constructor(readonly id: Metric) {}

  name = ko.observable('');
}
